<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import DefaultLayout from '@/views/layouts/DefaultLayout'

export default {
  name: 'App',
  computed: {
    layout() {
      return this.$route.meta.layout ?? DefaultLayout
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss">
@import "assets/css/custom.scss";
</style>
